import { PhoneOutlined } from '@ant-design/icons';

interface WhatsAppFloatingButtonProps {
  userName?: string | null;
  supportNumber?: string;
}

const defaultNumber = import.meta.env.VITE_WHATSAPP_SUPPORT_NUMBER;

export function WhatsAppFloatingButton({ userName, supportNumber }: WhatsAppFloatingButtonProps) {
  const number = supportNumber || defaultNumber;
  if (!number) return null;

  const encodedMessage = encodeURIComponent(
    `Olá, sou ${userName || 'cliente FlowHub'} e preciso de ajuda com uma automação.`
  );

  return (
    <a
      href={`https://wa.me/${number}?text=${encodedMessage}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        background: '#25D366',
        color: '#fff',
        borderRadius: '50%',
        width: 56,
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 12px 24px rgba(37,211,102,0.35)',
        zIndex: 1000,
      }}
    >
      <PhoneOutlined style={{ fontSize: 24 }} />
    </a>
  );
}
